import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties, getId, } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateCarouselJson(carouselJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // carouselJson => RichAssetCarousel => RichAsset => Node
    const parentNode = carouselJson?.$container?.$container
        ?.$container;
    const idField = getId(parentNode);
    // Each carousel item in the items array has an optional alt_text
    // property. We want to ensure that either all the options have
    // this property defined, or none of the options have it.
    let itemsCountWithAltText = 0;
    let itemsCountWithoutAltText = 0;
    carouselJson.items.forEach((item) => {
        const altTextProperty = item.properties.find((p) => ast.isAltTextProperty(p));
        if (altTextProperty) {
            itemsCountWithAltText++;
        }
        else {
            itemsCountWithoutAltText++;
        }
    });
    if (itemsCountWithAltText !== 0 && itemsCountWithoutAltText !== 0) {
        accept('error', `Use of alt_text property in the items is not consistent.`, {
            node: carouselJson,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
}
export function validateCarouselItem(carouselItem, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // CarouselItem => CarouselJson => RichAssetCarousel => RichAsset => Node
    const parentNode = carouselItem.$container?.$container?.$container
        ?.$container;
    const idField = getId(parentNode);
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: carouselItem,
        allProperties: carouselItem.properties,
        requiredProperties: [
            ast.TitleProperty,
            ast.ImageProperty,
            ast.LabelProperty,
            ast.DestProperty,
            ast.OptTextProperty,
        ],
        parentNode,
        accept,
    });
    // If the Additional CTA array is present, it should not
    // have more than 2 items.
    const additionalCtaArray = carouselItem.properties.find((prop) => {
        return ast.isAdditionalCtaArrayProperty(prop);
    });
    if (additionalCtaArray && additionalCtaArray.items?.length > 2) {
        accept('error', `Cannot have more than 2 items in the 'additional_cta' for carousel item.`, {
            node: additionalCtaArray,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
}
export function validateAdditionalCtaItem(additionalCtaItem, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // AdditionalCtaItem => AdditionalCtaArrayProperty => CarouselItem => CarouselJson => RichAssetCarousel => RichAsset => Node
    const parentNode = additionalCtaItem.$container?.$container?.$container
        ?.$container?.$container?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: additionalCtaItem,
        allProperties: additionalCtaItem.properties,
        requiredProperties: [ast.LabelProperty, ast.DestProperty],
        parentNode,
        accept,
    });
}
//# sourceMappingURL=carousel.js.map